import theme from '../../base';

const switchComponent = {
  default: {
    background: theme.colors.neutrals.gray500,
    thumbBackground: theme.colors.neutrals.white,
    border: theme.colors.neutrals.gray500,
  },
  disabled: {
    background: theme.colors.neutrals.gray800,
    thumbBackground: theme.colors.neutrals.gray700,
    border: theme.colors.neutrals.gray800,
  },
  focus: {
    border: theme.colors.blues.blue300,
  },
  selected: {
    background: theme.colors.blues.blue500,
    thumbBackground: theme.colors.neutrals.white,
    border: theme.colors.blues.blue500,
  },
  label: {
    foreground: theme.colors.neutrals.white,
  },
};

export default switchComponent;
